import {
    Button,
    Card,
    Divider,
    Flex,
    Heading,
    Icon,
    Image,
    Text,
    useBreakpointValue
} from '@chakra-ui/react';

import { FiExternalLink } from "react-icons/fi";

export function DonationDisplay ({}) {
    const isMobile = useBreakpointValue(
        {
          "base": ()=> true,
          "xl": ()=>  false
        }
    );  

    return(
        <>
            <Text mb={4}>
                A considerable amount of collective investment both in terms of time and money has been made into
                creating, improving, and maintaining the PGH Dance Game Space.  If you'd like to make additional contributions
                towards the space continuing in the future so that more events like this one can be hosted here, please donate!
            </Text>
            <Flex alignItems="flex-start" justifyContent="space-evenly" wrap="wrap" direction="row" gap={2}>
                <Button
                    display="block"
                    ml="auto"
                    mr="auto"
                    bgColor="green.500"
                    onClick={()=>{
                        window.open("https://pghdancegamespace.org/Support", '_blank').focus();
                    }}
                    _hover={{bgColor: "green.400"}}
                >
                    {isMobile() ? "Donate to PGH DG Space" : "Donate to PGH Dance Game Space"} &nbsp;<Icon as={FiExternalLink}/>
                </Button>
            </Flex>                  
        </>
    );
}